import React from 'react';
import AnimatedElement from '../components/AnimatedElement.js';

const EducationSection = () => (
    <section id="education" className="h-screen bg-brand-peach flex flex-col items-center justify-center relative overflow-hidden">
        <div className="absolute inset-0 z-0 text-center font-anton text-[10rem] md:text-[25rem] lg:text-[30rem] !leading-none opacity-20 text-outline select-none whitespace-nowrap">
            <div className="block">PROFESSOR</div>
            <div className="block -mt-10 md:-mt-20">PROFESSOR</div>
        </div>
        <AnimatedElement className="text-center z-10">
            <p className="text-brand-red text-2xl md:text-4xl">You can call me</p>
        </AnimatedElement>
    </section>
);

export default EducationSection;
